import React from "react";
import Turnover from "./../../assets/img/year-image1.jpg";
import Profit from "./../../assets/img/year-image2.jpg";
import Accumulated from "./../../assets/img/year-image3.jpg";
import Fixed from "./../../assets/img/year-image4_0.jpg";
import Reserve from "./../../assets/img/year-image5_0.jpg";
const Finance = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Finance</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <div className="row mb-1 justify-content-between">
          <div className="col-lg-12 mb-1">
            <p>
              The accounts of the Corporation are maintained in all Regional
              Offices in the State as well as at Head Office. The paid-up
              capital is Rs.500.00 Lac and Fixed Assets are Rs. 727.23 Lac
              (figures as on 31.03.2021).
            </p>
            <p>Results for the last three years are as under:</p>
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>YEAR</th>
                    <th>2018-2019</th>
                    <th>2019-2020</th>
                    <th>2020-2021</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <img alt="Turnover" src={Turnover} title="Turnover" />
                    </td>
                    <td>14654.95</td>
                    <td>14769.38</td>
                    <td>11537.32</td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        alt="Profit-Before-Tax"
                        src={Profit}
                        title="Profit-Before-Tax"
                      />
                    </td>
                    <td>630.64</td>
                    <td>456.70</td>
                    <td>317.77</td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        alt="Accumulated-profits"
                        src={Accumulated}
                        title="Accumulated-profits"
                      />
                    </td>
                    <td>505.71</td>
                    <td>804.78</td>
                    <td>1074.40</td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        alt="Fixed-Assets"
                        src={Fixed}
                        title="Fixed-Assets"
                      />
                    </td>
                    <td>748.16</td>
                    <td>661.33</td>
                    <td>727.23</td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        alt="Reserve and Surplus"
                        src={Reserve}
                        title="Reserve and Surplus"
                      />
                    </td>
                    <td>1624.44</td>
                    <td>2027.46</td>
                    <td>2216.13</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p>
              The working capital requirement is met with Cash Credit Limit
              arranged with Commercial Banks.
            </p>

            <h6>Audit</h6>

            <ul>
              <li>
                Statutory Audit is done by a firm of Chartered Accountants
                appointed by the Comptroller &amp; Auditor General of India, New
                Delhi.
              </li>
              <li>Tax Audit is done under section 44AB of Income Tax Act.</li>
              <li>
                Accounts also audited by the office of Principal Accountant
                General (Audit), Haryana.
              </li>
              <li>
                Internal Audit is done by the firm of Chartered Accountants
                appointed by the Board of Directors.
              </li>
            </ul>

            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <tbody>
                  
                  <tr>
                    <td>Status</td>
                    <td colspan="2">
                      Company registered under the Companies Act, 1956.
                    </td>
                  </tr>
                  <tr>
                    <td>Permanent Account No. (PAN No.)</td>
                    <td colspan="2">AAACH3951J</td>
                  </tr>
                  <tr>
                    <td rowspan="8">Tax Account No. (TAN)</td>
                    <td>RTKH01769F</td>
                    <td>Head OFFICE</td>
                  </tr>
                  <tr>
                    <td>RTKH02091F</td>
                    <td>UMRI</td>
                  </tr>
                  <tr>
                    <td>RTKH02086A</td>
                    <td>Y. NAGAR</td>
                  </tr>
                  <tr>
                    <td>RTKH02092G</td>
                    <td>HISAR</td>
                  </tr>
                  <tr>
                    <td>RTKH02087B</td>
                    <td>SIRSA</td>
                  </tr>
                  <tr>
                    <td>RTKH02090E</td>
                    <td>TOHANA</td>
                  </tr>
                  <tr>
                    <td>RTKH02088C</td>
                    <td>PATAUDI</td>
                  </tr>
                  <tr>
                    <td>RTKH02089D</td>
                    <td>BHIWANI</td>
                  </tr>
                  <tr>
                    <td>Assessing Authority</td>
                    <td colspan="2">
                      Assistant/ Deputy Commissioner of Income tax,
                      Panchkula Circle, Panchkula
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h6>GST</h6>

            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <tbody>
                 
                  <tr>
                    <td>Haryana</td>
                    <td>06AAACH3951J1ZM</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h6>Main Bankers -</h6>

            <ol>
              <li>Punjab National Bank, Mani Majra Chandigarh.</li>
              <li>Indian Bank, Sector-11, Panchkula.</li>
              <li>Union Bank of India, Sector-11, Panchkula.</li>
            </ol>

            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                 
                </thead>
                <tbody>
                  <tr>
                    <td>UMRI</td>
                    <td>Punjab National Bank, HSDC Complex Umri (KKR)</td>
                  </tr>
                  <tr>
                    <td>YAMUNA NAGAR</td>
                    <td>Punjab National Bank Railway Road, Yamuna Nagar</td>
                  </tr>
                  <tr>
                    <td>HISAR</td>
                    <td>Punjab National Bank Railway Road, Hisar</td>
                  </tr>
                  <tr>
                    <td>SIRSA</td>
                    <td>Punjab National Bank Rania Road, Sirsa</td>
                  </tr>
                  <tr>
                    <td>TOHANA</td>
                    <td>Punjab National Bank Chandigarh Road, Tohana</td>
                  </tr>
                  <tr>
                    <td>BHIWANI</td>
                    <td>Punjab National Bank Ghanta Ghar Chowk, Bhiwani</td>
                  </tr>
                  <tr>
                    <td>PATAUDI</td>
                    <td>Punjab National Bank, Pataudi</td>
                  </tr>
                  <tr>
                    <td colspan="2">&nbsp;</td>
                  </tr>
                  <tr>
                    <td>PROVIDENT FUND MAINTAINED</td>
                    <td>Regional Provident Fund Commissioner, Chandigarh</td>
                  </tr>
                  <tr>
                    <td>ACCOUNT NO.</td>
                    <td>PB/CHD/4711</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Finance;
